import React from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { cityTemplate } from './navEditorState';

// City tabs of one dropdown item, like the rendered BARCELONA / PORTO row.
const NavCityTabs = ({
  itemIndex, cities, selected, onSelect, onChange,
}) => (
  <Droppable droppableId={`cities-${itemIndex}`} direction="horizontal" type="CITY">
    {provided => (
      <div ref={provided.innerRef} {...provided.droppableProps} className="mnv-citytabs">
        {cities.map((city, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Draggable key={index} draggableId={`city-${itemIndex}-${index}`} index={index}>
            {p => (
              <div
                ref={p.innerRef}
                {...p.draggableProps}
                className={`mnv-citytab${selected === index ? ' mnv-citytab--on' : ''}${city.visible === false ? ' mnv-dim' : ''}`}
              >
                <span className="mnv-grip" {...p.dragHandleProps}>⋮⋮</span>
                <button type="button" onClick={() => onSelect(index)}>
                  {((city.title && city.title.en) || city.key || '(new)').toUpperCase()}
                </button>
              </div>
            )}
          </Draggable>
        ))}
        {provided.placeholder}
        <button
          type="button"
          className="mnv-add"
          onClick={() => { onChange([...cities, cityTemplate()]); onSelect(cities.length); }}
        >
          + city
        </button>
      </div>
    )}
  </Droppable>
);

NavCityTabs.propTypes = {
  itemIndex: PropTypes.number.isRequired,
  cities: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selected: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NavCityTabs;
